import { defaultTo, map, pipe, prop, renameKeys } from '@neo/ramda-extra'

export const mapToAddressViewModel = pipe(
  defaultTo({ searchDatum: [] }),
  prop('searchDatum'),
  map(renameKeys({ searchValue: 'propertyAddress' }))
)
